import type { AjaxError } from 'rxjs';
import type { Epic } from '@helpcenter/epics-rxjs';
import { Observable } from '@helpcenter/epics-rxjs';

import { resetPassword } from 'rest/reset-password';
import type { LoginAttempt } from 'state/actions/login';
import { loginAttempt } from 'state/actions/login';
import type { ResetPassword, ResetPasswordFailure } from 'state/actions/reset-password';
import { resetPasswordFailure, RESET_PASSWORD } from 'state/actions/reset-password';
import { getDefaultError } from 'utils/errors';
import FeatureGates from '@atlaskit/feature-gate-js-client';
import { OPERATIONAL_EVENT_TYPE } from '@atlassian/analytics-web-react';
import { sendEvent } from '@atlassian/help-center-common-util/analytics';

export const resetPasswordEpic: Epic<ResetPassword, ResetPasswordFailure | LoginAttempt> = (action$) => {
    return action$.ofType(RESET_PASSWORD).mergeMap((resetPasswordAction) => {
        const { emailAddress, password, token, resetPasswordJwt, createAnalyticsEvent, redirectUrl } =
            resetPasswordAction.payload;

        return resetPassword({ emailAddress, password, token, resetPasswordJwt })
            .map(() => {
                return loginAttempt({ password, email: emailAddress, continueParam: redirectUrl ?? null });
            })
            .catch((error: AjaxError) => {
                if (FeatureGates.checkGate('fire_analytics_for_reset_password_errors')) {
                    if (createAnalyticsEvent && error.status === 400) {
                        const event = createAnalyticsEvent({
                            analyticsType: OPERATIONAL_EVENT_TYPE,
                            actionSubject: 'submitNewPassword',
                            action: 'failed',
                        });
                        sendEvent(event);
                    }
                }
                return Observable.of(resetPasswordFailure(getDefaultError(error)));
            });
    });
};
